/**
 * Determines if a given URL is a News Subscription article.
 * Currently, this is for demonstration, and query strings aren't
 * going to be used in the finished product
 * @param {string} url
 */
export function isNbcSubsArticle(url) {
  const pattern = /\?subscriptions=true/;
  return pattern.test(url);
}
